import { render, staticRenderFns } from "./CollectionsWidget.vue?vue&type=template&id=12634ad2"
import script from "./CollectionsWidget.vue?vue&type=script&lang=js"
export * from "./CollectionsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports